exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-pinned main {\n  margin-top: 0;\n}\n.not-pinned .top-pinned {\n  position: static;\n  top: auto;\n  z-index: auto;\n}\n.top-pinned {\n  position: fixed;\n  width: 100%;\n  z-index: 20;\n  top: 0;\n}\nmain {\n  margin-top: 6rem;\n}", ""]);

// exports
